import type { IDataSourceDefinitionPresetOptionItem } from '../interfaces';

export const ALL_CONTINENTS: IDataSourceDefinitionPresetOptionItem[] = [
  { name: 'Africa', value: 'Africa' },
  { name: 'Asia', value: 'Asia' },
  { name: 'Australasia', value: 'Australasia' },
  { name: 'Europe', value: 'Europe' },
  { name: 'North America', value: 'North America' },
  { name: 'South America', value: 'South America' },
];

export const CONTINENT_COUNTRIES: Record<string, IDataSourceDefinitionPresetOptionItem[]> = {
  Africa: [
    { name: 'Algeria', value: 'DZ' },
    { name: 'Angola', value: 'AO' },
    { name: 'Benin', value: 'BJ' },
    { name: 'Botswana', value: 'BW' },
    { name: 'British Indian Ocean Territory', value: 'IO' },
    { name: 'Burkina Faso', value: 'BF' },
    { name: 'Burundi', value: 'BI' },
    { name: 'Cabo Verde', value: 'CV' },
    { name: 'Cameroon', value: 'CM' },
    { name: 'Central African Republic', value: 'CF' },
    { name: 'Chad', value: 'TD' },
    { name: 'Comoros', value: 'KM' },
    { name: 'Congo', value: 'CG' },
    { name: 'Congo Democratic Republic of', value: 'CD' },
    { name: "Côte d'Ivoire", value: 'CI' },
    { name: 'Djibouti', value: 'DJ' },
    { name: 'Egypt', value: 'EG' },
    { name: 'Equatorial Guinea', value: 'GQ' },
    { name: 'Eritrea', value: 'ER' },
    { name: 'Eswatini', value: 'SZ' },
    { name: 'Ethiopia', value: 'ET' },
    { name: 'French Southern Territories', value: 'TF' },
    { name: 'Gabon', value: 'GA' },
    { name: 'Gambia', value: 'GM' },
    { name: 'Ghana', value: 'GH' },
    { name: 'Guinea', value: 'GN' },
    { name: 'Guinea-Bissau', value: 'GW' },
    { name: 'Kenya', value: 'KE' },
    { name: 'Lesotho', value: 'LS' },
    { name: 'Liberia', value: 'LR' },
    { name: 'Libya', value: 'LY' },
    { name: 'Madagascar', value: 'MG' },
    { name: 'Malawi', value: 'MW' },
    { name: 'Mali', value: 'ML' },
    { name: 'Mauritania', value: 'MR' },
    { name: 'Mauritius', value: 'MU' },
    { name: 'Mayotte', value: 'YT' },
    { name: 'Morocco', value: 'MA' },
    { name: 'Mozambique', value: 'MZ' },
    { name: 'Namibia', value: 'NA' },
    { name: 'Niger', value: 'NE' },
    { name: 'Nigeria', value: 'NG' },
    { name: 'Réunion', value: 'RE' },
    { name: 'Rwanda', value: 'RW' },
    { name: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH' },
    { name: 'Sao Tome and Principe', value: 'ST' },
    { name: 'Senegal', value: 'SN' },
    { name: 'Seychelles', value: 'SC' },
    { name: 'Sierra Leone', value: 'SL' },
    { name: 'Somalia', value: 'SO' },
    { name: 'South Africa', value: 'ZA' },
    { name: 'South Sudan', value: 'SS' },
    { name: 'Sudan', value: 'SD' },
    { name: 'Tanzania United Republic of', value: 'TZ' },
    { name: 'Togo', value: 'TG' },
    { name: 'Tunisia', value: 'TN' },
    { name: 'Uganda', value: 'UG' },
    { name: 'Western Sahara', value: 'EH' },
    { name: 'Zambia', value: 'ZM' },
    { name: 'Zimbabwe', value: 'ZW' },
  ],
  Asia: [
    { name: 'Afghanistan', value: 'AF' },
    { name: 'Armenia', value: 'AM' },
    { name: 'Azerbaijan', value: 'AZ' },
    { name: 'Bahrain', value: 'BH' },
    { name: 'Bangladesh', value: 'BD' },
    { name: 'Bhutan', value: 'BT' },
    { name: 'Brunei Darussalam', value: 'BN' },
    { name: 'Cambodia', value: 'KH' },
    { name: 'China', value: 'CN' },
    { name: 'Cyprus', value: 'CY' },
    { name: 'Georgia', value: 'GE' },
    { name: 'Hong Kong', value: 'HK' },
    { name: 'India', value: 'IN' },
    { name: 'Indonesia', value: 'ID' },
    { name: 'Iran Islamic Republic Of', value: 'IR' },
    { name: 'Iraq', value: 'IQ' },
    { name: 'Israel', value: 'IL' },
    { name: 'Japan', value: 'JP' },
    { name: 'Jordan', value: 'JO' },
    { name: 'Kazakhstan', value: 'KZ' },
    { name: 'Kirgizstan', value: 'KG' },
    { name: 'Kuwait', value: 'KW' },
    { name: "Lao People'S Democratic Republic", value: 'LA' },
    { name: 'Lebanon', value: 'LB' },
    { name: 'Macao', value: 'MO' },
    { name: 'Malaysia', value: 'MY' },
    { name: 'Maldives', value: 'MV' },
    { name: 'Mongolia', value: 'MN' },
    { name: 'Myanmar', value: 'MM' },
    { name: 'Nepal', value: 'NP' },
    { name: 'North Korea', value: 'KP' },
    { name: 'Oman', value: 'OM' },
    { name: 'Pakistan', value: 'PK' },
    { name: 'Palestine, State of', value: 'PS' },
    { name: 'Philippines', value: 'PH' },
    { name: 'Qatar', value: 'QA' },
    { name: 'Saudi Arabia', value: 'SA' },
    { name: 'Singapore', value: 'SG' },
    { name: 'South Korea', value: 'KR' },
    { name: 'Sri Lanka', value: 'LK' },
    { name: 'Syrian Arab Republic', value: 'SY' },
    { name: 'Taiwan', value: 'TW' },
    { name: 'Tajikistan', value: 'TJ' },
    { name: 'Thailand', value: 'TH' },
    { name: 'Timor-Leste', value: 'TL' },
    { name: 'Turkey', value: 'TR' },
    { name: 'Turkmenistan', value: 'TM' },
    { name: 'United Arab Emirates', value: 'AE' },
    { name: 'Uzbekistan', value: 'UZ' },
    { name: 'Viet Nam', value: 'VN' },
    { name: 'Yemen', value: 'YE' },
  ],
  Australasia: [
    { name: 'American Samoa', value: 'AS' },
    { name: 'Australia', value: 'AU' },
    { name: 'Christmas Island', value: 'CX' },
    { name: 'Cocos (Keeling) Islands', value: 'CC' },
    { name: 'Cook Islands', value: 'CK' },
    { name: 'Fiji', value: 'FJ' },
    { name: 'French Polynesia', value: 'PF' },
    { name: 'Guam', value: 'GU' },
    { name: 'Heard Island and Mcdonald Islands', value: 'HM' },
    { name: 'Kiribati', value: 'KI' },
    { name: 'Marshall Islands', value: 'MH' },
    { name: 'Micronesia Federated States of', value: 'FM' },
    { name: 'Nauru', value: 'NR' },
    { name: 'New Caledonia', value: 'NC' },
    { name: 'New Zealand', value: 'NZ' },
    { name: 'Niue', value: 'NU' },
    { name: 'Norfolk Island', value: 'NF' },
    { name: 'Northern Mariana Islands', value: 'MP' },
    { name: 'Palau', value: 'PW' },
    { name: 'Papua New Guinea', value: 'PG' },
    { name: 'Pitcairn', value: 'PN' },
    { name: 'Samoa', value: 'WS' },
    { name: 'Solomon Islands', value: 'SB' },
    { name: 'Tokelau', value: 'TK' },
    { name: 'Tonga', value: 'TO' },
    { name: 'Tuvalu', value: 'TV' },
    { name: 'United States Minor Outlying Islands', value: 'UM' },
    { name: 'Vanuatu', value: 'VU' },
    { name: 'Wallis and Futuna', value: 'WF' },
  ],
  Europe: [
    { name: 'Åland Islands', value: 'AX' },
    { name: 'Albania', value: 'AL' },
    { name: 'Andorra', value: 'AD' },
    { name: 'Austria', value: 'AT' },
    { name: 'Belarus', value: 'BY' },
    { name: 'Belgium', value: 'BE' },
    { name: 'Bosnia and Herzegovina', value: 'BA' },
    { name: 'Bulgaria', value: 'BG' },
    { name: 'Croatia', value: 'HR' },
    { name: 'Cyprus', value: 'CY' },
    { name: 'Czech Republic', value: 'CZ' },
    { name: 'Czechia', value: 'CZ' },
    { name: 'Denmark', value: 'DK' },
    { name: 'Estonia', value: 'EE' },
    { name: 'Faroe Islands', value: 'FO' },
    { name: 'Finland', value: 'FI' },
    { name: 'France', value: 'FR' },
    { name: 'Germany', value: 'DE' },
    { name: 'Gibraltar', value: 'GI' },
    { name: 'Greece', value: 'GR' },
    { name: 'Guernsey', value: 'GG' },
    { name: 'Holy See (Vatican City State)', value: 'VA' },
    { name: 'Holy See', value: 'VA' },
    { name: 'Hungary', value: 'HU' },
    { name: 'Iceland', value: 'IS' },
    { name: 'Ireland', value: 'IE' },
    { name: 'Isle of Man', value: 'IM' },
    { name: 'Italy', value: 'IT' },
    { name: 'Jersey', value: 'JE' },
    { name: 'Latvia', value: 'LV' },
    { name: 'Liechtenstein', value: 'LI' },
    { name: 'Lithuania', value: 'LT' },
    { name: 'Luxembourg', value: 'LU' },
    { name: 'Macedonia  Former Yugoslav Republic of', value: 'MK' },
    { name: 'North Macedonia', value: 'MK' },
    { name: 'Malta', value: 'MT' },
    { name: 'Moldova Republic of', value: 'MD' },
    { name: 'Monaco', value: 'MC' },
    { name: 'Montenegro', value: 'ME' },
    { name: 'Netherlands', value: 'NL' },
    { name: 'Norway', value: 'NO' },
    { name: 'Poland', value: 'PL' },
    { name: 'Portugal', value: 'PT' },
    { name: 'Romania', value: 'RO' },
    { name: 'Russian Federation', value: 'RU' },
    { name: 'San Marino', value: 'SM' },
    { name: 'Serbia', value: 'RS' },
    { name: 'Serbia and Montenegro', value: 'CS' },
    { name: 'Slovakia', value: 'SK' },
    { name: 'Slovenia', value: 'SI' },
    { name: 'Spain', value: 'ES' },
    { name: 'Svalbard and Jan Mayen', value: 'SJ' },
    { name: 'Sweden', value: 'SE' },
    { name: 'Switzerland', value: 'CH' },
    { name: 'Ukraine', value: 'UA' },
    { name: 'United Kingdom', value: 'GB' },
    { name: 'United Kingdom of Great Britain and Northern Ireland', value: 'GB' },
  ],
  'North America': [
    { name: 'Bermuda', value: 'BM' },
    { name: 'Canada', value: 'CA' },
    { name: 'Greenland', value: 'GL' },
    { name: 'Saint Pierre and Miquelon', value: 'PM' },
    { name: 'United States', value: 'US' },
  ],
  'South America': [
    { name: 'Anguilla', value: 'AI' },
    { name: 'Antigua and Barbuda', value: 'AG' },
    { name: 'Argentina', value: 'AR' },
    { name: 'Aruba', value: 'AW' },
    { name: 'Bahamas', value: 'BS' },
    { name: 'Barbados', value: 'BB' },
    { name: 'Belize', value: 'BZ' },
    { name: 'Bolivia', value: 'BO' },
    { name: 'Bolivia (Plurinational State of)', value: 'BO' },
    { name: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
    { name: 'Bouvet Island', value: 'BV' },
    { name: 'Brazil', value: 'BR' },
    { name: 'Cayman Islands', value: 'KY' },
    { name: 'Colombia', value: 'CO' },
    { name: 'Costa Rica', value: 'CR' },
    { name: "Cote D'Ivoire", value: 'CI' },
    { name: 'Cuba', value: 'CU' },
    { name: 'Curaçao', value: 'CW' },
    { name: 'Dominica', value: 'DM' },
    { name: 'Dominican Republic', value: 'DO' },
    { name: 'Ecuador', value: 'EC' },
    { name: 'El Salvador', value: 'SV' },
    { name: 'Falkland Islands (Malvinas)', value: 'FK' },
    { name: 'French Guiana', value: 'GF' },
    { name: 'Grenada', value: 'GD' },
    { name: 'Guadeloupe', value: 'GP' },
    { name: 'Guatemala', value: 'GT' },
    { name: 'Guyana', value: 'GY' },
    { name: 'Haiti', value: 'HT' },
    { name: 'Honduras', value: 'HN' },
    { name: 'Jamaica', value: 'JM' },
    { name: 'Martinique', value: 'MQ' },
    { name: 'Mexico', value: 'MX' },
    { name: 'Montserrat', value: 'MS' },
    { name: 'Nicaragua', value: 'NI' },
    { name: 'Panama', value: 'PA' },
    { name: 'Paraguay', value: 'PY' },
    { name: 'Peru', value: 'PE' },
    { name: 'Puerto Rico', value: 'PR' },
    { name: 'Saint Barthélemy', value: 'BL' },
    { name: 'Saint Kitts and Nevis', value: 'KN' },
    { name: 'Saint Lucia', value: 'LC' },
    { name: 'Saint Martin (French part)', value: 'MF' },
    { name: 'Saint Vincent and the Grenadines', value: 'VC' },
    { name: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { name: 'Suriname', value: 'SR' },
    { name: 'Trinidad and Tobago', value: 'TT' },
    { name: 'Turks and Caicos Islands', value: 'TC' },
    { name: 'Uruguay', value: 'UY' },
    { name: 'Venezuela', value: 'VE' },
    { name: 'Venezuela (Bolivarian Republic of)', value: 'VE' },
    { name: 'Virgin Islands British', value: 'VG' },
    { name: 'Virgin Islands U.S.', value: 'VI' },
    { name: 'Virgin Islands (British)', value: 'VG' },
    { name: 'Virgin Islands (U.S.)', value: 'VI' },
    { name: 'Sint Maarten (Dutch part)', value: 'SX' },
  ],
};

export const CONTINENT_NAME_SWAPS: Record<string, string> = {
  'North America': 'N. America',
  'South America': 'S. America',
};
